import { render, staticRenderFns } from "./orderInfoByAdminModal.vue?vue&type=template&id=14a9140e&"
import script from "./orderInfoByAdminModal.vue?vue&type=script&lang=js&"
export * from "./orderInfoByAdminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports